export const headband = {
  msrp: 15.99,
  infoLink: 'https://www.teamtriton.com/custom-headbands.html',
  items: [
    {
      number: 'HB099',
      hasModel: false,
    },
    {
      number: 'HB100',
      hasModel: false,
    },
    {
      number: 'HB101',
      hasModel: false,
    },
    {
      number: 'HB102',
      hasModel: false,
    },
    {
      number: 'HB103',
      hasModel: false,
    },
    {
      number: 'HB104',
      hasModel: false,
    },
    {
      number: 'HB105',
      hasModel: false,
    },
    {
      number: 'HB106',
      hasModel: false,
    },
    {
      number: 'HB107',
      hasModel: false,
    },
    {
      number: 'HB108',
      hasModel: false,
    },
    {
      number: 'HB109',
      hasModel: false,
    },
    {
      number: 'HB110',
      hasModel: false,
    },
    {
      number: 'HB111',
      hasModel: false,
    },
    {
      number: 'HB112',
      hasModel: false,
    },
    {
      number: 'HB113',
      hasModel: false,
    },
    {
      number: 'HB114',
      hasModel: false,
    },
    {
      number: 'HB115',
      hasModel: false,
    },
    {
      number: 'HB116',
      hasModel: false,
    },
    {
      number: 'HB117',
      hasModel: false,
    },
    {
      number: 'HB118',
      hasModel: false,
    },
  ],
};
